import PropTypes from "prop-types";
import { CheckSolidV6, CloneSolidV6 } from "@shared/v2/Icomoon";
import maskApiKey from "@shared/maskApiKey";
import useCopyToClipboard from "@shared/hooks/useCopyToClipboard";

const ApiKeyInlineCopy = ({ apiKey }) => {
  const [hasCopied, copy] = useCopyToClipboard(2000);

  return (
    <span
      className={`tw-flex tw-items-center tw-text-neutral-gray-75 ${hasCopied ? "tw-gap-[12px]" : "tw-gap-[8px]"}`}
    >
      <span>{maskApiKey(apiKey)}</span>
      {hasCopied ? (
        <span className="tw-flex tw-items-center tw-gap-[4px]">
          <CheckSolidV6 className="tw-text-semantic-green-100" />
          Copied!
        </span>
      ) : (
        <button
          type="button"
          aria-label="Copy API key"
          className="tw-flex tw-p-0 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-neutral-gray-75"
          onClick={() => copy(apiKey)}
        >
          <CloneSolidV6 />
        </button>
      )}
    </span>
  );
};

ApiKeyInlineCopy.propTypes = {
  apiKey: PropTypes.string.isRequired,
};

export default ApiKeyInlineCopy;
